import React, { useEffect, useState } from 'react';
import MaskReal from 'services/formateRS';

import Button from "components/CustomButtons/Button.js";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Table from "components/Table/Table.js";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import CSVReader from "react-csv-reader";
import SomeSpinner from "components/Somespinner/Somespinner.js"

import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import DatePicker from "components/Datepicker/Datepicker";
import api from "assets/services/api";


const useStyles2 = makeStyles(styles2);


function ModalTransferStorage(props) {

    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    }

    const classes2 = useStyles2();
    const { storageId } = useAuth();

    const [br, setBR] = React.useState(false);

    const [products, setProducts] = useState([]);
    const [listProducts, setListProducts] = useState([]);

    const [productId, setProductId] = useState(0);
    const [amount, setAmount] = useState();
    const [startDate, setStartDate] = useState(new Date().withoutTime());
    const [controlSnack, setControlSnack] = useState(false);

    let id_admin_in;
    switch (storageId) {
        case 8:
            id_admin_in = 11;
            break;

        case 11:
            id_admin_in = 8;
            break;

        default:
            break;
    }

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        loadProducts();
    }, []);

    useEffect(() => {
        if (controlSnack) showNotification("br");
    }, [controlSnack]);


    async function addToList(e) {
        e.preventDefault();
        let order;

        if (amount === undefined || amount <= 0) {
            return alert('Quantidade inválida');
        }

        let theProduct;
        let theProductCode;
        const id_product = productId ? parseInt(productId) : products[0].id
        for (let i = 0; i < products.length; i++) {
            if (products[i].id === id_product) {
                theProduct = products[i].name;
                theProductCode = products[i].new_code;
                break;
            }
        }
        let box;
        for (let i = 0; i < products.length; i++) {
            if (products[i].id === id_product) {
                box = products[i].box;
                break;
            }
        }
        const totalBox = amount / box;
        order = { name: theProduct, amount, totalBox, id_product, code: theProductCode };
        setListProducts(prevOrder => ([...prevOrder, order]));

    }

    async function deleteToList(index) {
        let listNew = [...listProducts];
        listNew.splice(index, 1);
        setListProducts(listNew);
    }

    async function cleanList() {
        let listNew = [];
        setListProducts(listNew);
    }

    async function loadProducts() {
        const response = await api.get('/product/admin/' + storageId);
        setProducts(response.data);
    }

    const tableData = () => {
        let teste = [];

        for (let i = 0; i < listProducts.length; i++) {
            teste[i] = [];
            teste[i].push(listProducts[i].name);
            teste[i].push(listProducts[i].amount);
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip
                        id="tooltip-top-start"
                        title="Deletar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Close"
                            className={classes2.tableActionButton}
                            onClick={() => deleteToList()}
                        >
                            <Close
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.close
                                }
                            />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        }
        return teste;
    }

    async function transferStorage(e) {
        try {
            if (listProducts.length === 0) {
                const msg = 'Selecione pelo menos um produto';
                return alert(msg);
            }

            const response = await api.post(`/storage/transfer`, {
                id_admin_in,
                id_admin_out: storageId,
                date_of_issued: startDate,
                list_products: listProducts
            })
            if (response.status === 200) {
                setControlSnack(true);
                if (response.data.erros.length > 0) {
                    let msg = '';
                    response.data.erros.forEach(element => {
                        msg = msg + `${element.product}, quantidade solicitada ${element.amount_in}, quantidade em estoque: ${element.amount_out}\n`;
                    });
                    alert(msg);
                }
                props.onHide();
            }
        } catch (error) {

        }
    }

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered

        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Transferir Estoque para {id_admin_in === 8 ? "BA" : "SE"}
                </Modal.Title>
            </Modal.Header>
            <Form >
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridProduct">
                            <Form.Label>Produtos</Form.Label>
                            <Form.Control onChange={event => setProductId(event.target.value)} as="select" defaultValue="Choose...">
                                {products.map((product, index) => (
                                    <option key={String(index)} value={product.id}>{product.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridAmount">
                            <Form.Label>Quantidade</Form.Label>
                            <Form.Control onChange={event => setAmount(event.target.value)} type="double" placeholder="Quantidade de produtos" />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridDate">
                            <Form.Label>Data</Form.Label>
                            <div>
                                <DatePicker
                                    selected={startDate}
                                    onChange={date => setStartDate(date.withoutTime())}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Digite ou clique aqui"
                                    disabledKeyboardNavigation />
                            </div>
                        </Form.Group>
                    </Form.Row>

                    <div className="d-flex justify-content-center mt-3">
                        <Button color="success" onClick={(e) => (addToList(e))}>
                            Adicionar a lista
                        </Button>
                        <Button color="success" onClick={cleanList}>
                            Limpar a lista
                        </Button>
                    </div>
                    {<Form.Row>
                        <Table
                            tableHeaderColor="danger"
                            tableHead={["Produto", "Quantidade", "Ações"]}
                            tableData={tableData()}
                        />
                    </Form.Row>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" onClick={(e) => transferStorage(e)}>
                            Concluir
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message={"estoque transferido com sucesso"}
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalTransferStorage;